export const paramsList = {
    cases_at_start: "Остаток дел на начало отчетного периода",
    cases_canceled: "Отменено постановлений о возбуждении уголовного дела",
    cases_accepted: "Принято к производству дел",
    cases_transferred_without_indictment: "Передано прокурором дел органов дознания для производства предварительного следствия (без обвинительного акта)",
    percent_transferred_without_indictment: "Удельный вес от числа принятых в %",
    cases_transferred_with_indictment: "Направлено прокурором дел с обвинительным актом для производства предварительного следствия",
    percent_transferred_with_indictment: "Удельный вес от числа принятых в %",
    cases_in_process: "Находилось дел в производстве",
    cases_per_investigator: "Количество находившихся в производстве дел на 1 шт. единицу следователя",
    cases_completed: "Окончено дел",
    cases_sent_to_prosecutor: "Направлено дел прокурору (с повторными) с обвинительным заключением либо актом, постановлением о применении принудительных мер медицинского характера",
    cases_sent_to_court_with_indictment: "Направлено прокурором в суд - с обвинительным заключением",
    cases_sent_to_court_with_medical_measures: "С постановлением о применении принудительных мер медицинского характера",
    cases_sent_to_court_juvenile: "Направлено дел в суд с постановлением о прекращении уголовного преследования и возбуждении перед судом ходатайства о применении к н/летнему обвиняемому принудительной меры воспитательного воздействия в порядке ч. 1 ст. 427 УПК РФ",
    cases_sent_to_court_with_fine: "Направлено дел в суд в порядке ч. 2 ст. 446.2 УПК РФ",
    cases_returned_by_court: "Возвращено дел для производства дополнительного следствия",
    percent_cases_returned: "Удельный вес возвращенных дел от числа направленных в суд в порядке ч. 2 ст. 446.2 УПК РФ в %",
    cases_terminated: "Прекращено дел из числа оконченных",
    percent_cases_terminated: "Удельный вес прекращенных дел от числа оконченных в %",
    completed_cases_per_investigator: "Количество дел на 1 шт. единицу следователя - оконченных производством",
    court_cases_per_investigator: "По направленным в суд делам",
    accused_in_court_cases: "Число обвиняемых по направленным в суд делам",
    juvenile_accused: "Число несовершеннолетних обвиняемых по делам, направленным в суд в порядке ч. 1 ст. 427 УПК РФ",
    persons_with_court_fine: "Число лиц по уголовным делам, направленным в суд в порядке ч. 2 ст. 446.2 УПК РФ",
    persons_with_terminated_cases: "Число лиц по прекращенным делам",
    cases_investigated: "Расследовано дел (оконченных и приостановленных)",
    investigated_cases_per_investigator: "Количество расследованных дел на 1 шт. единицу следователя",
    cases_suspended: "Приостановлено производством дел",
    percent_cases_suspended: "Удельный вес приостановленных дел от числа расследованных в %",
    cases_suspended_special: "Из них по п. 1-3 ч. 1 ст. 208 УПК РФ (в связи с неустановлением лица)",
    cases_returned_for_investigation: "Возвращено дел для производства дополнительного следствия",
    percent_cases_returned_to_prosecutor: "Удельный вес от числа направленных прокурору дел в %",
    cases_returned_by_prosecutor: "В том числе - прокурором",
    percent_cases_returned_by_prosecutor: "Удельный вес к числу возвращенных дел в %",
    cases_returned_by_court_article_237: "Судом в порядке ст. 237 УПК РФ",
    cases_completed_overtime: "Окончено дел в сроки свыше предусмотренного УПК РФ",
    cases_resumed_from_suspended: "В том числе - возобновленных производством из числа ранее приостановленных дел",
    percent_cases_completed_overtime: "Удельный вес дел, оконченных в сроки свыше УПК РФ за исключением возобновленных производством из числа ранее приостановленных дел, от числа направленных прокурору, в суд в порядке ч. 1 ст. 427 и ч. 2 ст. 446.2 УПК РФ и прекращенных в %",
    persons_rehabilitated: "Число лиц, в отношении которых дела прекращены с реабилитацией",
    persons_acquitted: "Из них - лица, по делам о которых постановлены оправдательные приговоры",
    persons_detained_rehabilitated: "Число лиц, в отношении которых избрана мера пресечения в виде заключения под стражу, из числа реабилитированных",
    cases_at_end: "Остаток дел на конец отчетного периода",
    pending_cases_per_investigator: "Количество нерасследованных дел на 1 шт.единицу следователя",
    staff_count: "Фактическая штатная численность"
};

export const reportMonthParamsList = {
    "accepted_to_production_current": "Принято к производству дел - текущий период",
    "accepted_to_production_previous": "Принято к производству дел - АППГ",
    "accepted_to_production_difference": "Принято к производству дел - разница к АППГ",

    "completed_cases_current": "Окончено дел - текущий период",
    "completed_cases_previous": "Окончено дел - АППГ",
    "completed_cases_difference": "Окончено дел - разница к АППГ",

    "terminated_cases_current": "Прекращено дел - текущий период",
    "terminated_cases_previous": "Прекращено дел - АППГ",
    "terminated_cases_difference": "Прекращено дел - разница к АППГ",
    "terminated_percentage_current": "Прекращено дел - % к оконченным",
    "terminated_percentage_previous": "Прекращено дел - % к оконченным за АППГ",

    "sent_to_court_current": "Направлено дел в суд - текущий период",
    "sent_to_court_previous": "Направлено дел в суд - АППГ",
    "sent_to_court_difference": "Направлено дел в суд - разница к АППГ",

    "investigated_cases_current": "Расследовано дел - текущий период",
    "investigated_cases_previous": "Расследовано дел - АППГ",
    "investigated_cases_difference": "Расследовано дел - разница к АППГ",

    "suspended_cases_current": "Приостановлено дел - текущий период",
    "suspended_cases_previous": "Приостановлено дел - АППГ",
    "suspended_cases_difference": "Приостановлено дел - разница к АППГ",
    "suspended_percentage_current": "Приостановлено дел - % к расследованным",
    "suspended_percentage_previous": "Приостановлено дел - % к расследованным за АППГ",

    "returned_for_investigation_current": "Возвращено прокурором дел - текущий период",
    "returned_for_investigation_previous": "Возвращено прокурором дел - АППГ",
    "returned_for_investigation_difference": "Возвращено прокурором дел - разница к АППГ",
    "returned_percentage_current": "Возвращено прокурором дел - % к направленным прокурору",
    "returned_percentage_previous": "Возвращено прокурором дел - % к направленным прокурору за АППГ",

    "completed_overdue_current": "Окончено дел в сроки свыше УПК - текущий период",
    "completed_overdue_previous": "Окончено дел в сроки свыше УПК - АППГ",
    "completed_overdue_difference": "Окончено дел в сроки свыше УПК - разница к АППГ",
    "overdue_percentage_current": "Окончено дел в сроки свыше УПК - % от числа направленных прокурору с обвинительным заключением и прекращенных",
    "overdue_percentage_previous": "Окончено дел в сроки свыше УПК - % от числа направленных прокурору с обвинительным заключением и прекращенных за АППГ",

    "rehabilitated_persons_current": "Число лиц, в отношении которых уголовное преследование прекращено по реабилитирующим основаниям - текущий период",
    "rehabilitated_persons_previous": "Число лиц, в отношении которых уголовное преследование прекращено по реабилитирующим основаниям - АППГ",

    "acquitted_persons_current": "Число оправданных и лиц, в отношении которых уголовное преследование прекращено судом по реабилитирующим основаниям - текущий период",
    "acquitted_persons_previous": "Число оправданных и лиц, в отношении которых уголовное преследование прекращено судом по реабилитирующим основаниям - АППГ",

    "detained_rehabilitated_current": "Содержалось под стражей лиц из числа оправданных или дела которых прекращены по реабилитирующим основаниям - текущий период",
    "detained_rehabilitated_previous": "Содержалось под стражей лиц из числа оправданных или дела которых прекращены по реабилитирующим основаниям - АППГ"
};

export const reportYearParamsList = {
    "year": "Год",

    "accepted_to_production": "Принято к производству дел",
    "completed_cases": "Окончено дел (с повторными)",
    "sent_to_prosecutor": "Направлено дел прокурору (с повторными) с обвинительным заключением либо актом, постановлением о применении принудительных мер медицинского характера",

    "prosecutor_decisions_to_court": "С обвинительным заключением либо актом",
    "prosecutor_decisions_medical_measures": "С постановлением о применении принудительных мер медицинского характера",
    "prosecutor_decisions_terminated": "Прекращено (в стр.14 не включать)",
    "returned_for_investigation": "Возвращено дел для дополнительного расследования",

    "court_petition_427": "Направлено дел в суд с постановлением о возбуждении перед судом ходатайства по ч. 1 ст. 427 УПК РФ",
    "court_petition_446": "Направлено в суд с постановлением о возбуждении ходатайства по ч. 2 ст. 446.2 УПК РФ",
    "terminated_cases": "Прекращено дел (с повторными) только следователями",

    "suspended_unidentified_person": "Неустановление лица",
    "suspended_location_unknown": "Неустановленные места нахождения",
    "suspended_no_possibility": "Отсутствия возможности",

    "investigated_overdue": "Расследовано дел в сроки свыше установленного УПК (из суммы строк 5 и 14) с возобн",
    "terminated_rehabilitating": "Число лиц, в отношении которых производство прекращено за отсутствием события, состава преступления, а также уголовное преследование прекращено за непричастностью",
    "terminated_rehabilitating_detained": "из них содержалось под стражей",
    "acquitted_and_terminated": "Число оправданных и лиц, дела о которых прекращены судом за отсутствием события или состава преступления, а также в связи с непричастностью",
    "acquitted_and_terminated_detained": "из них содержалось под стражей"
};

export type ParamsListKey = keyof typeof paramsList;
